import * as Actions from '../actions';

const initialState = {
    assetList: [],
    fileList: [],
    videoProgress: 0,
    videoCompleted: 0
}

const assetReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_ASSET_LIST):
        {
            return {
                ...state,
                assetList: action.payload
            };
        }
        case (Actions.GET_MODEL_FILE_LIST):
        {
            return {
                ...state,
                fileList: action.payload
            }
        }
        case (Actions.GET_MODEL_ASSET_LIST):
        {
            return {
                ...state,
                assetList: action.payload
            }
        }
        case (Actions.GET_VIDEO_PROGRESS):
        {
            return {
                ...state,
                videoProgress: action.payload.Progress,
                videoCompleted: action.payload.Completed
            }
        }
        case (Actions.RESET_VIDEO_PROGRESS):
        {
            return {
                ...state,
                videoProgress: action.payload
            }
        }
        default:
        {
            return state;
        }
    }
}


export default assetReducer;



// WEBPACK FOOTER //
// src/main/content/asset/store/reducers/asset.reducer.js